import React, {useState, useEffect, useRef} from 'react';
import './timer-exercise.css';

const TimerExercise = ({handleMoveExerciseAnimation, exerciseDuration, handleStartNextStep}) => {
  const [initialTime, setInitialTime] = useState(exerciseDuration);
  const [timeLeft, setTimeLeft] = useState(exerciseDuration); // Час, що залишився
  const [isRunning, setIsRunning] = useState(true); // Статус таймера
  const [progress, setProgress] = useState(0); // Прогрес від 0 до 100
  const canvasRef = useRef(null); // Посилання на canvas для малювання елементів для таймеру
  const intervalRef = useRef(null); // Для збереження id інтервалу
  const startTimeRef = useRef(Date.now()); // Час запуску таймера для розрахунку прогресу
  const timeRemainingRef = useRef(initialTime); // Зберігаємо час залишковий під час паузи

  // Оновлення прогресу в реальному часі (кожну мілісекунду)
  useEffect(() => {
    if (!isRunning) return;

    const updateProgress = () => {
      const elapsedTime = (Date.now() - startTimeRef.current) / 1000; // Час, що пройшов в секундах
      const timeRemaining = Math.max(0, timeRemainingRef.current - elapsedTime); // Час, що залишився
      setTimeLeft(timeRemaining);

      // Обчислення прогресу (від 0 до 100)
      if (exerciseDuration !== undefined) {
        const currentProgress = ((initialTime - timeRemaining) / initialTime) * 100;
        setProgress(currentProgress);
      }

      // Якщо час ще не вичерпано, повторно викликаємо updateProgress
      if (timeRemaining === 0) {
        clearInterval(intervalRef.current); // Зупиняємо інтервал, коли час вичерпано
        setIsRunning(false);
        handleStartNextStep(prev => prev + 1);
      }
    }

    // Почати оновлення прогресу
    intervalRef.current = setInterval(updateProgress, 10); // Оновлюємо кожні 100 мс

    // Очистка функції, коли таймер зупинений
    return () => {
      clearInterval(intervalRef.current); // Очищаємо інтервал при відміні
    };
    // }
  }, [isRunning]);

  // Малювання прогрес-бару на canvas
  useEffect(() => {
    if (!canvasRef.current) return;
    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');
    let width = 160;  // Фізичний розмір канвасу на екрані
    let height = 160; // Фізичний розмір канвасу на екрані

    if (window.innerWidth > 355 && window.innerWidth < 376) {
      width = 130;
      height = 130;
    } else if (window.innerWidth <= 355) {
      width = 110;
      height = 110;
    }

    const scale = window.devicePixelRatio || 1; // Множник для масштабування

    // Встановлюємо канвас на фізичний розмір (160px) через CSS
    canvas.style.width = `${width}px`;
    canvas.style.height = `${height}px`;

    // Встановлюємо внутрішні розміри канвасу з урахуванням devicePixelRatio
    canvas.width = width * scale;
    canvas.height = height * scale;

    // Масштабуємо контекст канвасу
    ctx.scale(scale, scale);

    const radius = width / 2;
    const startAngle = -Math.PI / 2; // Початковий кут (зверху)
    const progressColor = '#E5DDFF'; // Колір прогресу
    const endAngle = startAngle + (2 * Math.PI * (progress / 100));

    // Очищаємо попереднє зображення
    ctx.clearRect(0, 0, canvas.width, canvas.height);

    // Малюємо фон
    ctx.beginPath();
    ctx.arc(radius, radius, radius - 10, 0, 2 * Math.PI);
    ctx.strokeStyle = '#6F525C';
    ctx.lineWidth = 3;
    ctx.stroke();

    // Малюємо прогрес
    ctx.beginPath();
    ctx.arc(radius, radius, radius - 10, startAngle, endAngle);
    ctx.strokeStyle = progressColor; // Лерповий (плавний) колір
    ctx.lineWidth = 3;
    ctx.stroke();

    // Нерухоме (статичне) коло
    const staticCircleRadius = 6.15; // Радіус статичного кола
    const staticCircleX = radius; // X координата (центр кола)
    const staticCircleY = radius - radius + 10; // Y координата (верхня точка)

    // Малюємо статичне коло, яке не рухається
    ctx.beginPath();
    ctx.arc(staticCircleX, staticCircleY, staticCircleRadius, 0, 2 * Math.PI);
    ctx.fillStyle = '#6F525C'; // Колір статичного кола
    ctx.fill();
  }, [progress]);

  const handlePause = () => {
    if (!isRunning) return;
    handleMoveExerciseAnimation(true);
    setIsRunning(false); // Зупинити таймер
    timeRemainingRef.current = timeLeft; // Зберегти час при паузі
    clearInterval(intervalRef.current); // Зупинити інтервал
  };

  const handleResume = () => {
    if (isRunning) return;
    handleMoveExerciseAnimation(false);
    startTimeRef.current = Date.now(); // Оновлюємо час старту для коректного продовження
    setIsRunning(true); // Продовжити таймер
  };

  return (
    <div className='timer-container'>
      <canvas className='timer-circle'
              ref={canvasRef}
      ></canvas>
      <div
        className={`time-remaining ${isRunning ? 'time-visible' : ''} `}
        onClick={handlePause}>
        {Math.ceil(timeLeft)}
      </div>
      <div
        className={`resume-time ${!isRunning ? 'time-visible' : ''}`}
        onClick={handleResume}>
        <img loading="lazy"
             src={require('./timer-exercise-img/play-img.svg').default}
             width={36}
             height={48}
             alt="image for exercise continue"/>
      </div>
    </div>
  );
};

export default TimerExercise;
